import React from "react"
import CustomPageHeader from "../../fragments/CustomPageHeader"

export default function FinancierBuckets({ children }) {
  return (
    <div>
      <CustomPageHeader icon='folder' text='Buckets' />
      { children }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Buckets/index.js